var _style, _path, _path2, _ellipse, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedication(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "medication_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 148 148",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".medication_svg__st0{fill:none;stroke:var(--color-text);stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "medication_svg__st0",
    d: "M30.1 99.5c-3.9-3.9-3.9-10.3 0-14.2l16.7-16.7c3.9-3.9 10.3-3.9 14.2 0 3.9 3.9 3.9 10.3 0 14.2L44.4 99.5c-4 3.9-10.3 3.9-14.3 0zM38.5 76.9l14.2 14.2M78.6 89.1V62.4c0-2.6-.9-5.1-2.6-7.1L64.2 40.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "medication_svg__st0",
    d: "M27 40.8L15.1 55.2c-1.7 2-2.6 4.5-2.6 7.1V116c0 6.2 5 11.2 11.2 11.2h43.6c2 0 4-.5 5.6-1.5M68.3 40.8H23c-3.8 0-6.9-3.1-6.9-6.9v-6.1c0-3.8 3.1-6.9 6.9-6.9h45.3c3.8 0 6.9 3.1 6.9 6.9v6.1c0 3.8-3.1 6.9-6.9 6.9zM35.4 27v7.2M45.6 27v7.2M55.8 27v7.2M124.5 106.6c-4.4 2.9-11.7 5.6-24.9 5.6-13.8 0-24.9-4.7-24.9-10.5 0-2.6 2.2-4.9 5.9-6.8M124.5 116.7c0 5.8-11.2 10.5-24.9 10.5s-24.9-4.7-24.9-10.5M124.5 116.7v-10.1M74.7 116.7v-15.1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "medication_svg__st0",
    cx: 111,
    cy: 76.5,
    rx: 24.9,
    ry: 10.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111 81c-10.4 0-16.8-2.8-18.6-4.5 1.8-1.6 8.2-4.5 18.6-4.5s16.8 2.8 18.6 4.5c-1.8 1.6-8.2 4.5-18.6 4.5z",
    fill: "var(--color-icon-primary)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "medication_svg__st0",
    d: "M135.9 91.6c0 5.8-11.2 10.5-24.9 10.5s-24.9-4.7-24.9-10.5M135.9 91.6V76.5M86.1 91.6V76.5"
  })));
}
export default SvgMedication;